import { ActionButton } from '@react-spectrum/s2';
import { useCallback } from 'react';

import { PromptSparkleIcon } from '@/components/icons/PromptSparkleIcon';
import { useChatInputSeed } from '@/spaces/chat/ChatInputSeedContext.tsx';

import { RailTooltip } from './RailTooltip';
import { toolRailButtonClass } from './toolRail';

// Pressing this rail button doesn't edit the image directly — it prefills the chat
// composer with this opener and flashes it, so the user describes the edit in words
// and the normal edit_image chat round-trip does the work. The trailing two spaces
// place the cursor a clear gap after the colon; keep them.
const VIBE_EDIT_SEED = 'Edit this image:  ';

export const VibeEditButton = () => {
	const { seedChatInput } = useChatInputSeed();
	const handleVibeEdit = useCallback(
		() => seedChatInput(VIBE_EDIT_SEED, { flash: true }),
		[seedChatInput],
	);
	return (
		<RailTooltip label="Edit in Chat">
			<ActionButton
				aria-label="Edit in Chat"
				data-testid="vibe-edit-button"
				onPress={handleVibeEdit}
				UNSAFE_className={toolRailButtonClass}
			>
				<PromptSparkleIcon />
			</ActionButton>
		</RailTooltip>
	);
};
